import React from 'react';
import LoadingScreen from './LoadingScreen';

interface TriEventsLoadingScreenProps {
    loading?: boolean;
    children?: React.ReactNode;
}

const TriEventsLoadingScreen = ({ loading = true, children }: TriEventsLoadingScreenProps) => (
    <LoadingScreen isLoading={loading}>
        {children}
    </LoadingScreen>
);

export default TriEventsLoadingScreen;